import { MetadataDictionary, MetadataType } from '@mkp/metadata/models';
import { Metadata } from '@mkp/shared/models';

export const isMetadata = (object: unknown): object is Metadata =>
  (object as Metadata)?.id !== undefined && (object as Metadata)?.text !== undefined;

export const sortMetadataDictionary = (entities: MetadataDictionary): MetadataDictionary => {
  return Object.entries(entities).reduce((acc, [type, metadatas]) => {
    const sortFunction = getSortingFunction(type as MetadataType);

    return {
      ...acc,
      [type]: sortFunction ? [...metadatas].sort(sortFunction) : metadatas,
    };
  }, {} as MetadataDictionary);
};

type MetadataSortFunction = (l1: Metadata, l2: Metadata) => number;

// JMP-4462: display a few languages before the others (left side displayed first, right side displayed last)
const languageOrders = ['de', 'en', 'fr', 'it'].reverse();
const getLanguageOrder = (metadata: Metadata): number =>
  languageOrders.findIndex((languageOrder) => languageOrder === metadata.id) ?? 0;
const sortLanguage: MetadataSortFunction = (l1, l2) =>
  getLanguageOrder(l2) - getLanguageOrder(l1) || l1.text.localeCompare(l2.text);

const sortLanguageLevel: MetadataSortFunction = (l1, l2) => Number(l2.id) - Number(l1.id);
const getSortingFunction = (type: MetadataType): MetadataSortFunction | null => {
  switch (type) {
    case 'language': {
      return sortLanguage;
    }
    case 'languageLvl': {
      return sortLanguageLevel;
    }
    default: {
      return null;
    }
  }
};
